module.exports = __webpack_public_path__ + "static/img/icon_thcx.2f7c947.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/index/icon_thcx.png
// module id = GBua
// module chunks = 11